module.exports = __webpack_public_path__ + "static/media/Tracking.b7ea3a72.svg";